import { cn, generateRdsId } from '@ctct/summit-core';
import { type ComponentPropsWithoutRef } from 'react';

const TAG_INPUT_FIELD_RDS_ID = generateRdsId('tag-input-field');

const inputClasses = `
  r:min-w-32
  r:flex-1
  r:focus:outline-none
  r:focus:ring-0
  r:disabled:bg-transparent
`;
const TagInputField = ({
  id,
  value,
  placeholder,
  onChange,
  onKeyDown,
  disabled,
  className,
  ...props
}: ComponentPropsWithoutRef<'input'>) => {
  const handleChange = onChange;
  const handleKeyDown = onKeyDown;

  return (
    <input
      id={id}
      type="text"
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      className={cn(TAG_INPUT_FIELD_RDS_ID, inputClasses, className)}
      data-testid={TAG_INPUT_FIELD_RDS_ID}
      data-sds-id="tag-input-field"
      {...props}
    />
  );
};

export { TAG_INPUT_FIELD_RDS_ID, TagInputField };
